import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { ScrollPanel } from 'primereact/scrollpanel'
import { SplitButton } from 'primereact/splitbutton'
import { Toast } from 'primereact/toast'
import { string } from 'modules'
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { clearProgrammeDraftResultsTitlesAction } from 'components/Body/data-entry/AudioVisual/store/actions'
import { EnglishLanguageId } from 'modules/Constants'
import { selectIsPrimaryTitleInvalid, selectPrimaryTitle, selectAreProgrammeLanguagesInvalid, selectAreProgrammeTitlesInvalid, selectProgrammeTitles } from 'components/Body/data-entry/AudioVisual/store/selectors'
import { setPrimaryTitleAction, setIsProgrammePrimaryTitleInvalidAction, setAreProgrammeLanguagesInvalidAction, setAreProgrammeTitlesInvalidAction, setProgrammeTitlesAction } from 'components/Body/data-entry/AudioVisual/store/actions'

// ReSharper disable once InconsistentNaming
const EditTitles = (props) => {
    //Deconstruct props
    const {
        showPanel,
        setShowPanel,
        primarytitle,
        languages,
        selectTitles,
        setTitlestoStore,
        programmeDataOriginalAltTitles
    } = props

    const toast = useRef(null)
    const dispatch = useDispatch()
    const setAcceptedTitles = (titlesToAccept) => dispatch(setTitlestoStore(titlesToAccept))
    const setPrimaryTitle = (primaryTitle) => dispatch(setPrimaryTitleAction(primaryTitle))
    const setIsProgrammePrimaryTitleInvalid = (flag) => dispatch(setIsProgrammePrimaryTitleInvalidAction(flag))
    const setAreProgrammeLanguagesInvalid = (flag) => dispatch(setAreProgrammeLanguagesInvalidAction(flag))
    const setAreProgrammeTitlesInvalid = (flag) => dispatch(setAreProgrammeTitlesInvalidAction(flag))
    const setProgrammeTitles = (programmeTitles) => dispatch(setProgrammeTitlesAction(programmeTitles))

    const presentationTitles = useSelector(selectTitles)
    const titles = useSelector(selectProgrammeTitles)
    const areTitlesInvalid = useSelector(selectAreProgrammeTitlesInvalid)
    const areLanguagesInvalid = useSelector(selectAreProgrammeLanguagesInvalid)
    const primaryTitle = useSelector(selectPrimaryTitle)
    const isPrimaryTitleInvalid = useSelector(selectIsPrimaryTitleInvalid)    
    const [draftTitles, setDraftTitles] = useState({})   

    const setInitialTitles = (resultTitles) => {
        const titlesArray = Object.values(resultTitles)
        const getPrimary = titlesArray.find(title => title.titleTypeId === 1)
        setPrimaryTitle(getPrimary ? getPrimary.title : '')
        const getSecondary = titlesArray.filter(title => title.titleTypeId !== 1)
        setProgrammeTitles(getSecondary)
        setIsProgrammePrimaryTitleInvalid(false)
        setAreProgrammeTitlesInvalid([])
        setAreProgrammeLanguagesInvalid([])
    }  

    //TODO: Add selector
    useEffect(() => {
        if (presentationTitles && (primaryTitle === '' || Object.keys(draftTitles).length === 0)) {
            setInitialTitles(presentationTitles)
            if (Object.keys(presentationTitles).length === 1) {
                const newTitle = { title: '', languageId: null, titleTypeId: 2 }
                setProgrammeTitles([newTitle])

            }
        }
        else if (!presentationTitles) {
            const newTitle = { title: '', languageId: null, titleTypeId: 2 }
            setProgrammeTitles([newTitle])
            setIsProgrammePrimaryTitleInvalid(false)
            setAreProgrammeTitlesInvalid([])
            setPrimaryTitle('')
            setAreProgrammeLanguagesInvalid([])

        }
    }, [presentationTitles])

    useEffect(() => {
        if ((!titles || titles.length === 0) && Object.keys(draftTitles).length === 0) {
            const newTitle = { title: '', languageId: null, titleTypeId: 2 }
            setProgrammeTitles([newTitle])
            if (primaryTitle) {
                setPrimaryTitle(primaryTitle)
            }
            else {
                setPrimaryTitle('')
            }
            setIsProgrammePrimaryTitleInvalid(false)
            setAreProgrammeTitlesInvalid([])
            setAreProgrammeLanguagesInvalid([])
        }
    }, [titles, draftTitles, primaryTitle])

    //Accept Split Buttom Items
    const saveModalItems = [
        {
            label: 'Accept Changes',
            icon: 'fa-light fa-check',
            command: () => {
                if (!validateChanges()) {
                    return
                }
                toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Changes accepted successfully', life: 3000 })
            }
        },
        {
            label: 'Accept Changes and Exit',
            icon: 'fa-light fa-check',
            command: () => {
                if (!validateChanges()) {
                    return
                }
                toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Changes accepted successfully' })
                setTimeout(() => {
                    setShowPanel(false)
                }, 500)
            }
        }
    ]
    //On direct click of Accept in split button
    const splitSave = () => {
        if (!validateChanges()) {
            return
        }
        if (!draftTitles || Object.keys(draftTitles).length === 0) {
            return
        }
        else {

            toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Changes accepted successfully', life: 3000 })
        }
    }

    const areTitlesDifferent = (newTitles, originalTitles) => {
        if (newTitles.length !== originalTitles.length) {
            return true
        }

        for (let i = 0; i < newTitles.length; i++) {
            const title = newTitles[i]
            const originalTitle = originalTitles[i]

            if (title.title !== originalTitle.title || title.languageId !== originalTitle.languageId || title.titleTypeId !== originalTitle.titleTypeId) {
                return true
            }
        }

        return false
    }
    //Cancel Save 

    const showCancelConfirm = (event) => {
        const originalTitlesNotEmpty = programmeDataOriginalAltTitles && programmeDataOriginalAltTitles.length > 0
        if ((draftTitles && Object.keys(draftTitles).length > 0) || (originalTitlesNotEmpty && areTitlesDifferent(titles, programmeDataOriginalAltTitles))) {
            confirmPopup({
                target: event.currentTarget,
                message: 'You have unsaved changes. Do you want to discard them?',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                accept
            })
        }
        else {
            setShowPanel(false)
        }
    }

    const accept = () => {
        //todo: No need to revert to original, remove titles from draft
        setInitialTitles(presentationTitles) //revert to original on cancel
        setDraftTitles({}) //clear draft titles
        dispatch(clearProgrammeDraftResultsTitlesAction()) //remove draft titles from store
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'Pending changes are cancelled', life: 3000 })
        setTimeout(() => {
            setShowPanel(false)
        }, 500) //close the panel
    }

    const isGuid = (id) => {
        const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
        return guidRegex.test(id)
    }

    /** Validattions **/
    const validateDuplicates = (array, primary) => {
        const seen = new Set()
        let hasDuplicates = false

        array.forEach((item, index) => {
            // Check if the item matches the primary title (both title and languageId)
            if (item.title === primary.title && item.languageId === primary.languageId) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Duplication Error',
                    detail: `Row ${index + 1} matches the primary title`,
                    life: 3000
                })
                hasDuplicates = true
            }

            const uniqueKey = `${item.title}-${item.languageId}` // Combine title and languageId as a unique key
            if (seen.has(uniqueKey)) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Duplication Error',
                    detail: `Duplicate found at row ${index + 1}: Title "${item.title}" with the same language`,
                    life: 3000
                })
                hasDuplicates = true
            } else {
                seen.add(uniqueKey) // Add the unique key to the set
            }
        })

        return hasDuplicates
    }

    const removeEmptyRows = (array) => {
        return array.filter(title => {
            if (!title.title && !title.languageId) {
                return false
            }
            return true
        })
    }

    const validateChanges = () => {
        let isValid = true
        const titlesArray = Object.values(presentationTitles)
        const getPrimary = titlesArray.find(title => title.titleTypeId === 1)
        // Check if primary title is empty
        if (string.isNullOrWhitespace(primaryTitle)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Main title cannot be empty' })
            setIsProgrammePrimaryTitleInvalid(true)
            isValid = false
        } else {
            setIsProgrammePrimaryTitleInvalid(false)
        }

        const nonEmptyTitles = removeEmptyRows(titles)
        if (nonEmptyTitles.length > 0) {
            setProgrammeTitles(nonEmptyTitles)

            // Check for duplicates
            if (validateDuplicates(titles, getPrimary)) {
                isValid = false
            }
            // Check if all titles have title filled...
            const invalidTitles = nonEmptyTitles.map((title, index) => {
                if (string.isNullOrWhitespace(title.title)) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: `Title at index ${index} must have both language and title filled` })
                    return true
                }
                return false
            })
            // If any titles are invalid, the whole record is invalid
            setAreProgrammeTitlesInvalid(invalidTitles)
            if (invalidTitles.some(invalid => invalid)) {
                isValid = false
            }
            // Language Id must be filled too
            const invalidLanguages = nonEmptyTitles.map((title, index) => {
                if (!title.languageId) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: `Language at index ${index} must have both language and title filled` })
                    return true
                }
                return false
            })
            setAreProgrammeLanguagesInvalid(invalidLanguages)
            if (invalidLanguages.some(invalid => invalid)) {
                isValid = false
            }
        }
        else {
            if (titles.length > 1) {
                setProgrammeTitles([titles[0]])
            }
        }

        // If all validations pass
        return isValid
    }

    //Add New Row

    const addNewRow = (index) => {
        const newTitle = { title: '', languageId: null, titleTypeId: 2 }
        setProgrammeTitles([
            ...titles.slice(0, index + 1),
            newTitle,
            ...titles.slice(index + 1)
        ])

        toast.current.show({ severity: 'info', summary: 'Add', detail: 'New Row Added' })
    }

    //Delete Row

    const deleteRow = (index) => {
        const newTitles = titles.filter((_, i) => i !== index)
        setProgrammeTitles(newTitles)
        setDraftTitles(newTitles)
        const mainTitle = presentationTitles?.find(title => title.titleTypeId === 1)
        const combinedTitles = mainTitle ? [mainTitle, ...newTitles] : newTitles
        setAcceptedTitles(combinedTitles)
    }

    //Add and Delete Row split button options

    const buttonModelItems = [
        {
            label: 'Add',
            icon: 'fa-thin fa-plus',
            command: (index) => addNewRow(index)
        },
        {
            label: 'Delete',
            icon: 'fa-light fa-minus',
            command: (index) => deleteRow(index)
        }
    ]

    const buttonModelItemsWithIndex = (index) => buttonModelItems.map(item => {
        return { ...item, command: () => item.command(index) }
    })

    //On change of Main Title
    const handleMainTitleChange = (e) => {
        const newTitle = e.target.value
        const titlesArray = Object.values(presentationTitles)
        const originalObjectIndex = titlesArray.findIndex(title => title.titleTypeId === 1)
        const newTitles = titlesArray.map((title, i) => {
            if (i === originalObjectIndex) {

                return {
                    ...title,
                    title: newTitle
                }
            }
            return title
        })
        setPrimaryTitle(newTitle)
        setAcceptedTitles(newTitles)
        setDraftTitles(newTitles)
        return undefined
    }


    //On change of Title and Language

    const handleInputChange = (index, field, value) => {
        const newTitles = titles.map((title, i) => {
            if (i === index) {

                return {
                    ...title,
                    [field]: value,
                    titleTypeId: field === 'languageId'
                        ? (value === EnglishLanguageId ? 2 : 3)
                        : title.titleTypeId
                }
            }
            return title
        })
        setProgrammeTitles(newTitles)
        const mainTitle = presentationTitles?.find(title => title.titleTypeId === 1)
        const combinedTitles = mainTitle ? [mainTitle, ...newTitles] : newTitles
        setAcceptedTitles(combinedTitles)
        setDraftTitles(combinedTitles)

    }

    //Footer for Dialog

    const footer = (
        <div className="app-footer">
            <SplitButton className='green mr-2 mt-2' label="Accept" icon="fa-light fa-check" onClick={splitSave} dropdownIcon="fa-light fa-chevron-down" model={saveModalItems} />
            <Button label="Cancel" icon="fa-light fa-xmark" className="yellow mt-2 mr-3 " raised onClick={showCancelConfirm} ></Button>
        </div>
    )

    return (
        <Dialog
            header={<div><span id="edit-titles-dialog-header minwidth-zero text-truncate">Edit Titles: </span><span style={{ fontWeight: 'bold' }}>{primarytitle && primarytitle.title}</span></div>}
            visible={showPanel}
            style={{ width: '40vw' }}
            footer={footer}
            onHide={(e) => showCancelConfirm(e || { currentTarget: document.querySelector("#edit-titles-dialog .p-dialog-header-icons") })}
            closable={true}
            maximizable={false}
            modal
            draggable={false}
            id="edit-titles-dialog"
        >
            <div className="sub-panel">
                <Toast ref={toast} />
                <ConfirmPopup />
                <div id="main-title">
                    <p className="label-input mb-1">Main Title</p>
                    <div className="d-flex align-items-center">
                        <InputText id="maintitle" value={primaryTitle} onChange={handleMainTitleChange} invalid={isPrimaryTitleInvalid} className=" av-radio-option form-control mb-3" style={{ width: '90%' }} />
                    </div>
                </div>
                <fieldset className="mt-2">
                    <legend>Other Titles</legend>
                    <div className="other-titles">
                        <ScrollPanel className="mt-2" style={{ height: '300px' }}>
                            {titles && titles.length > 0 && (titles.map((title, index) => (
                                <div key={index} className="row mb-2 dotted-separator" >
                                    <div className="col-md-5">
                                        <p className="label-input mb-1">Language</p>
                                        <Dropdown id="language" value={titles && titles[index] && titles[index].languageId} options={languages} filter onChange={(e) => handleInputChange(index, 'languageId', e.value.id)} placeholder={titles[index].languageId && languages.find(lang => lang.id === titles[index].languageId)?.name}
                                            className="custom-full-width mb-2" style={{ height: '53%' }} invalid={areLanguagesInvalid[index]} optionLabel="name"
                                            optionValue="id" />
                                    </div>
                                    <div className="col-md-5">
                                        <p className="label-input mb-1">Title</p>
                                        <InputText id="title" value={titles && titles[index] && titles[index].title} onChange={(e) => handleInputChange(index, 'title', e.target.value)} className=" av-radio-option form-control mb-2 custom-full-width" invalid={areTitlesInvalid[index]} />
                                    </div>
                                    <div className="col-md-2">
                                        <SplitButton className='modal-only mt-4' rounded onClick={splitSave} dropdownIcon="fa-light fa-plus-minus" model={buttonModelItemsWithIndex(index)} />
                                    </div>
                                </div>
                            )))}

                        </ScrollPanel>
                    </div>
                </fieldset>
            </div>
        </Dialog >
    )
}
export default EditTitles;
